import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import Footer from './Footer';

const navItems = [
  { label: 'Home', href: '/' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'For Developers', href: '/for-developers' },
  { label: 'Community', href: '/community' },
];

/**
 * PageShell — a wrapper for non-home pages that reuses the brand
 * background + logo + a simple top nav. The visible homepage layout
 * is untouched; this is for /how-it-works, /for-developers, /community.
 */
export default function PageShell({ children }) {
  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflowX: 'hidden' }}>
      {/* Fixed background — same assets as homepage */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundImage: { xs: "url('/mobbg.png')", sm: "url('/bgbanner.jpg')" },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: -10,
        }}
      />

      {/* Top nav */}
      <Box
        component="nav"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 2, sm: 4, md: 6 },
          py: { xs: 2, sm: 3 },
          position: 'relative',
          zIndex: 20,
        }}
      >
        <Box
          component="a"
          href="/"
          aria-label="BingePlay home"
          sx={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <Box
            component="img"
            src="/Logo1.svg"
            alt="BingePlay"
            sx={{ width: { xs: 48, sm: 60, lg: 72 } }}
          />
        </Box>
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            gap: { sm: 2, md: 4 },
            alignItems: 'center',
          }}
        >
          {navItems.map((n) => (
            <Typography
              key={n.href}
              component="a"
              href={n.href}
              sx={{
                color: '#fff',
                fontFamily: 'Poppins',
                fontWeight: 600,
                textTransform: 'uppercase',
                fontSize: { sm: 12, md: 13, lg: 14 },
                letterSpacing: '0.06em',
                textDecoration: 'none',
                '&:hover': { opacity: 0.7 },
              }}
            >
              {n.label}
            </Typography>
          ))}
          <Button
            href="https://app.funizzle.com/login"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              bgcolor: '#ef4444',
              fontFamily: 'Poppins',
              fontSize: { sm: 12, md: 13 },
              borderRadius: '10px',
              px: { sm: 2.2, md: 2.8 },
              py: { sm: 0.8, md: 1 },
              '&:hover': { bgcolor: '#dc2626' },
            }}
          >
            Sign Up Now
          </Button>
        </Box>
      </Box>

      {/* Page content */}
      <Box sx={{ position: 'relative', zIndex: 10, pb: { xs: 6, sm: 10 } }}>{children}</Box>
      <Footer />
    </Box>
  );
}

PageShell.propTypes = {
  children: PropTypes.node,
};
